<template>
  <div>
    <div class="section1 safe-area">
      <pageTitle cn="闭环课程" en="Closed-Loop Curriculum" type="1"></pageTitle>
      <div class="common-title-d1 mt-20">配套四大赛道 PBL 社团标准化课程，多学科融合教学，夯实探究方法、创作逻辑、赛事规则，助力学生完成项目全流程落地。</div>
      <div class="common-title-d2 mt-12">Standardized PBL club courses tailored to the four major tracks, featuring interdisciplinary teaching to reinforce inquiry methods, creative logic, and competition rules, helping students successfully implement projects from start to finish.</div>
      <div class="page-flex-lr-center-between">
        <div class="s1-item">
          <img :src="$env.imgUrl + 'study1-s1-1.png'" alt="">
          <div class="s1-item-cn">巴蜀地区</div>
        </div>
        <div class="s1-item">
          <img :src="$env.imgUrl + 'study1-s1-2.png'" alt="">
          <div class="s1-item-cn">荆楚地区</div>
        </div>
        <div class="s1-item">
          <img :src="$env.imgUrl + 'study1-s1-3.png'" alt="">
          <div class="s1-item-cn">吴越地区</div>
        </div>
        <div class="s1-item">
          <img :src="$env.imgUrl + 'study1-s1-4.png'" alt="">
          <div class="s1-item-cn">岭南地区</div>
        </div>
      </div>
    </div>
    <div class="section2" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <pageTitle cn="全套资源" en="Complete Resource Package" type="2"></pageTitle>
        <div class="common-title-d3 mt-20">每赛道配备 4-8 课时教学课件、教案、任务单、评价量表、多媒体素材，大幅减轻教师备课压力。</div>
        <div class="common-title-d4 mt-12">Each track includes 4–8 class periods’ worth of instructional presentations, lesson plans, worksheets, assessment rubrics, and multimedia materials, significantly reducing the burden on teachers when preparing lessons.</div>
        <img class="mt-20" :src="$env.imgUrl + 'study1-s2.png'" alt="">

        <!-- <div class="page-flex-lr-center-between mt-20">
          <img :src="$env.imgUrl + 'study1-s2-1.png'" alt="">
          <img :src="$env.imgUrl + 'study1-s2-2.png'" alt="">
          <img :src="$env.imgUrl + 'study1-s2-3.png'" alt="">
        </div> -->
      </div>
    </div>
    <div class="section3">
      <div class="safe-area">
        <pageTitle cn="名师集训" en="Master Teacher Boot Camp" type="1"></pageTitle>
        <div class="common-title-d1 mt-20">专项教师培育计划，系统培训 PBL 授课、项目指导、作品打磨、赛事评审全流程实操技巧。</div>
        <div class="common-title-d2 mt-12">A specialized teacher development program offering systematic training in practical skills for the entire PBL teaching process—including lesson delivery, project guidance, portfolio refinement, and competition judging.</div>
        <div class="page-flex-lr-center-between mt-20">
          <img :src="$env.imgUrl + 'study1-s3-1.png'" alt="">
          <img :src="$env.imgUrl + 'study1-s3-2.png'" alt="">
        </div>
      </div>
    </div>
    <div class="section4" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-2.png);'">
      <div class="safe-area">
        <pageTitle cn="材料包" en="Resource Kits" type="2"></pageTitle>
        <div class="page-flex-lr-center">
          <div class="lf">
            <div class="common-title-d3 mt-20">组委会组织专家学者联合研发专业的配套资源，精心打造各不同主题材料包，让学生思考有灵感，行动有抓手。</div>
            <div class="common-title-d4 mt-12">The organizing committee has brought together experts and scholars to jointly develop specialized supporting materials, carefully crafting resource kits on various themes to inspire students’ thinking and provide them with practical tools for action.</div>
            <div class="tit">材料包选购通道</div>
            <div class="entit">Kit Purchase Portal</div>
            <div class="common-title-d3 mt-12">售卖分赛道标准化调研工具、创作耗材、研学记录手册、展板设计模板，一站式配齐备赛物料。</div>
            <div class="common-title-d4 mt-12">We sell standardized research tools for different competition tracks, creative consumables, research and learning record manuals, and exhibition board design templates, providing a one-stop solution for all competition materials.</div>
            <div class="btn">
              <div class="btn-cn">点击购买</div>
              <div class="btn-en">Click to Buy</div>
            </div>
          </div>
          <div class="rt">
            <img :src="$env.imgUrl + 'study1-s4.png'" alt="">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style scoped lang="less">
.mt-20{
  margin-top: 20px;
}
.section1{
  padding: 30px 0 40px;
  .s1-item{
    width: 23%;
    margin-top: 20px;
    img{
      width: 100%;
      height: auto;
    }
    .s1-item-cn{
      font-family: systh;
      font-size: 16px;
      color: #000;
      text-align: center;
      margin-top: 10px;
    }
  }
}
.section2{
  padding: 80px 0;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  img{
    width: 100%;
  }
}
.section3 {
  padding: 20px 0 40px;
  img{
    width: 49%;
    height: auto;
  }
}
.section4{
  padding: 120px 0 80px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .tit{
    font-family: alih;
    color: #fff;
    font-size: 16px;
    margin-top: 20px;
  }
  .entit{
    font-size: 12px;
    color: #FD8E86;
  }
  .lf{
    width: 45%;
  }
  .rt{
    margin-left: 20px;
    flex: 1;
  }
  .btn{
    width: 200px;
    height: 40px;
    background-color: #fff;
    color: #C9273A;
    border-radius: 40px;
    text-align: center;
    padding-top: 6px;
    box-sizing: border-box;
    margin-top: 20px;
    .btn-cn{
      font-size: 14px;
      font-family: alih;
    }
    .btn-en{
      font-size: 10px;
    }
  }
}
</style>
